import { gql } from '@apollo/client';

export const GET_CONVERTED_IMAGE = gql`
  query GetConvertedImage($outputFormat: String!, $inputBase64: String!, $fileName: String!) {
    convertImageFromBase64(
      outputFormat: $outputFormat
      inputBase64: $inputBase64
      fileName: $fileName
    ) @client
  }
`;
